<div class="modals np-compact-pack-info" [class.modals-show]="isModalShow">
  <div class="np-compact-pack-info-head">
    Після упаковки замовлення може нараховуватись додаткова плата за пакувальні матеріали
    <ng-container *ngIf="npCompactPackBoxPrice">
      ({{ npCompactPackBoxPrice }} грн)
    </ng-container>
  </div>
  <div class="np-compact-pack-info-buttons-container">
    <button class="button" (click)="agree()">Погоджуюсь</button>
    <button class="button" (click)="notAgree()">Відмовитись</button>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground"></div>
